import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { forwardRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import RovingTabIndexItem from './roving-tab-index-item';
export default forwardRef(function TreeGridItem(_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return createElement(RovingTabIndexItem, _extends({
    ref: ref
  }, props), children);
});
//# sourceMappingURL=item.js.map